import React from 'react';

export default function IndexSectionApplication2() {
    return (
        <React.Fragment>
            <>
                <section className="bg-green-100 py-20">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap items-center -m-4">
                            <div className="w-full lg:w-7/12 p-4 mb-10 lg:mb-0">
                                <h1 className="font-heading text-4xl lg:text-5xl font-bold mb-4">Finding restaurants has
                                    never been more fun</h1>
                                <p className="text-gray-600 mb-6 max-w-lg">We use AI to find the best place to eat near
                                    you, wherever you are. FindAMeal combines the data of multiple food review providers
                                    and your personal preferences to find new restaurants and cafes for you.</p>
                                <div className="flex flex-wrap gap-4">
                                    <a className="inline-block"
                                       href="https://apps.apple.com/us/app/findameal/id6736911377">
                                        <img src="cronos-assets/buttons/app-store.svg" alt/>
                                    </a>
                                    <a className="inline-block"
                                       href="https://play.google.com/store/apps/details?id=ai.findameal">
                                        <img src="cronos-assets/buttons/google-play.svg" alt/>
                                    </a>
                                </div>
                            </div>
                            <div className="w-full lg:w-5/12 p-4">
                                <img className="mx-auto block" style={{maxHeight: 556}}
                                     src="https://static.shuffle.dev/uploads/files/91/912295578c198379538e8973cd408b5d4407df70/2-photos-cover.png"
                                     alt/>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        </React.Fragment>
    );
}

